import React, { useRef } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-types-papi';
import { useHeroImageForContainer } from '@wix/da-shared-react/pkg/utils/hooks/useHeroImageForContainer';

import s from './ProfileHeroV2.scss';

export interface Props {
  coverDeviation: PapiDeviation;
  showProfileHeroAid?: boolean;
  className?: string;
}

export const ProfileHeroV2: React.FC<Props> = ({
  coverDeviation,
  showProfileHeroAid,
  className,
}) => {
  const rootDivRef = useRef<HTMLDivElement>(null);
  const { hero: image } = useHeroImageForContainer(coverDeviation, rootDivRef);

  return (
    <div
      ref={rootDivRef}
      className={classnames(
        s['root'],
        !image && s['no-image'],
        showProfileHeroAid && s['is-ftue'],
        className
      )}
      style={{
        backgroundImage: image ? `url(${image.src})` : undefined,
      }}
    >
      {showProfileHeroAid && <div className={s['meteors']} />}
    </div>
  );
};
ProfileHeroV2.displayName = 'ProfileHeroV2';

export default ProfileHeroV2;
